import React, { useEffect, useRef, useState } from "react";
import {
	Button,
	CheckPicker,
	Checkbox,
	Modal,
	RangeSlider,
	SelectPicker,
} from "rsuite";
import "./portfolio.scss";
import { useDispatch, useSelector } from "react-redux";
import {
	getPortfolioFilters,
	getPortfolioDistrictData,
	getPortfolioGapSKULevelData,
	getPortfolioProductData,
	getPortfolioGapExportData,
	updatePortfolioGap,
} from "../../queries/apiQueries";
import PortfolioTable from "./portfolioTable";
import ProductGroupDetails from "./productGroupDetails";
import { numberFormatter } from "../../utils";
import MainHeader from "../../components/Layouts/MainHeader";
import MainContent from "../../components/Layouts/MainContent";
import { Loader } from "../../components/common/Loader";
import { CSVLink } from "react-csv";
import { useToaster, Notification } from "rsuite";
import FileDownloadIcon from "@rsuite/icons/FileDownload";
import { getTimelineOptions } from "../../config/constants";
export type ProductData = {
	district: string;
	product_group_id: string;
	product_group_description: string;
	total_national_sales: number;
	average_national_gm: number;
	additional_potential_quantity: number;
	potential_incremental_sales: number;
	benefits_from_incremental_sales: number;
	recomendedGM: number;
};

const csvHeaders = [
	{ label: "L1", key: "l1" },
	{ label: "L2", key: "l2" },
	{ label: "L3", key: "l3" },
	{ label: "L4", key: "l4" },
	{ label: "District", key: "district" },
	{ label: "Product Group ID", key: "groupid" },
	{ label: "Product Group Description", key: "substitueGroup" },
	{ label: "Item ID", key: "material_material" },
	{ label: "Part Number", key: "MAN_PART_NO" },
	{ label: "Supplier Name", key: "master_vendor_name" },
	{ label: "Sales ($)", key: "totalNationalSales" },
	{ label: "Gross Margin (%)", key: "averageNationalGM" },
	{ label: "Quantity", key: "qtyPerSKU" },
	{ label: "Net Cost ($/U)", key: "unitCost" },
	{ label: "Sell Price ($/U)", key: "unitPrice" },
	{ label: "Additional Potential Quantity", key: "additionalQty" },
	{ label: "Potential Incremental Sales ($)", key: "additionalSales" },
	{ label: "Benefit from Incremental Sales ($)", key: "marginBenefits" },
];

const PortfolioGap = () => {
	const timelineOptions=getTimelineOptions()
	const [isVisible, setIsVisible] = useState(false);
	const dispatch = useDispatch<any>();
	const toaster = useToaster();

	const footerStyles = {
		padding: "10px 2px",
		borderTop: "1px solid #e5e5e5",
	};

	const [filtersLoading, setFiltersLoading] = useState(true);
	const [tableLoading, setTableLoading] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [selectedDistrict, setSelectedDistrict] = useState<null | string>(
		null
	);
	const [tableData, setTableData] = useState<any>([]);
	const [updatedMaterialList, setUpdatedMaterialList] = useState<any>([]);
	const [updatedMaterialDetails, setUpdatedMaterialDetails] = useState<any>(
		[]
	);
	const [savePayload, setSavePayload] = useState<any>({});
	const allFilters = useSelector(
		(state: any) => state.CommonReducer.allFilters
	);
	const timeline = useSelector((state: any) => state.CommonReducer.timeline);

	const [filterOptions, updateFilterOptions] = useState<any>({
		l1: new Array<{ l1: string }>(),
		l2: new Array<{ l2: string }>(),
		l3: new Array<{ l3: string }>(),
		district: new Array<{ district: string }>(),
		supplier: new Array<{ vendor: string }>(),
		priority: new Array<{ vendor: string }>(),
	});

	const [selectedFilters, setSelectedFilters] = useState<any>({
		...allFilters,
		priority: [],
	});

	const [value, setValue] = useState<[number, number]>([0, 0]);
	const [valueR, setValueR] = useState<[number, number]>([0, 0]);
	const [minSliderValue, setMinSliderValue] = useState(0);
	const [maxSliderValue, setMaxSliderValue] = useState(0);
	const [minRevenueSliderValue, setMinRevenueSliderValue] = useState(0);
	const [maxRevenueSliderValue, setMaxRevenueSliderValue] = useState(0);
	const [isRightVisible, setIsRightVisible] = useState(false);
	const [productData, setProductData] = useState<ProductData[] | null>(null);
	const [exportData, setExportData] = useState<any>([]);

	const [skuLoading, setSkuLoading] = useState<boolean>(false);
	/* Define type once payload finalizes */
	const [product_group_id, setProduct_group_id] = useState<string | null>(
		null
	);
	const [selected_product, set_Selected_product] =
		useState<ProductData | null>(null);
	const [product_group_id_data, setProduct_group_id_data] = useState<any>([]);

	const didMount: any = useRef(false);
	const exportFullRef = useRef<any>(null);

	const [selectedTimeline, setSelectedTimeline] = useState(
		timeline ? timeline : getTimelineOptions()[0]?.value
	);

	useEffect(() => {
		getFilters();
		if (selectedFilters.priority.length > 0) {
			getDistrictData();
		}
	}, []);

	useEffect(() => {
		if (exportData?.length !== 0) {
			exportFullRef?.current?.link.click();
		}
	}, [exportData]);

	useEffect(() => {
		getDistrictData({}, true);
	}, [selectedFilters]);

	/* on changing timeline */
	const timelineHandler = (e: any) => {
		setSelectedTimeline(e === null ? "All" : e);
	};

	/* Filters api call */
	const getFilters = async (
		payload: any = {},
		currentFilter: any = "all"
	) => {
		setFiltersLoading(true);
		if (payload.supplier) {
			payload.vendor_name = payload.supplier;
			delete payload.supplier;
		}
		let res = await dispatch(getPortfolioFilters(payload));
		if (res.priority) {
			res.priority = res.priority.filter(
				(obj: any) => obj?.vendor !== "NA"
			);
		}
		if (selectedFilters.priority.length < 1) {
			setSelectedFilters({
				...selectedFilters,
				["priority"]: [res.priority[0].vendor],
			});
		}
		if (res.minmax) {
			let min: any = ~~Number(res.minmax[0].minGm * 100);
			let max: any = res.minmax[0].maxGm * 100;
			setMinSliderValue(min);
			setMaxSliderValue(max);
			if (!didMount.current) {
				setValue([min, max]);
			}
		}
		if (res?.minmaxR) {
			let minR: any = res.minmaxR[0]?.minR;
			let maxR: any = Math.ceil(res?.minmaxR[0]?.maxR);
			let diff = maxR % 10000;
			maxR = maxR - diff;
			setMinRevenueSliderValue(minR);
			setMaxRevenueSliderValue(maxR);
			setValueR([minR, maxR]);
		}
		if (currentFilter === "district") {
			updateFilterOptions({
				...filterOptions,
				l1: [...res.l1],
				l2: [...res.l2],
				l3: [...res.l3],
				supplier: [...res.suppliers],
				priority: [...res.priority],
			});
		} else if (currentFilter === "l1") {
			updateFilterOptions({
				...filterOptions,
				l2: [...res.l2],
				l3: [...res.l3],
				supplier: [...res.suppliers],
				priority: [...res.priority],
			});
		} else if (currentFilter === "l2") {
			updateFilterOptions({
				...filterOptions,
				l3: [...res.l3],
				supplier: [...res.suppliers],
				priority: [...res.priority],
			});
		} else if (currentFilter === "l3") {
			updateFilterOptions({
				...filterOptions,
				supplier: [...res.suppliers],
				priority: [...res.priority],
			});
		} else if (currentFilter === "supplier") {
			updateFilterOptions({
				...filterOptions,
				priority: [...res.priority],
			});
		} else if (currentFilter === "priority") {
			updateFilterOptions({ ...filterOptions });
		} else {
			updateFilterOptions({
				l1: res.l1,
				l2: res.l2,
				l3: res.l3,
				district: res.districts,
				supplier: res.suppliers,
				priority: res.priority,
			});
		}
		setIsLoading(false);
		setFiltersLoading(false);
		didMount.current = true;
	};

	const getDistrictData = async (
		payload: any = {},
		filterChange: boolean = false
	) => {
		if (selectedFilters.priority.length > 0) {
			let min = minSliderValue;
			let max = maxSliderValue;
			let minR = minRevenueSliderValue;
			let maxR = maxRevenueSliderValue;
			if (payload.newSlidervalue) {
				min = payload.newSlidervalue[0];
				max = payload.newSlidervalue[1];
				minR = valueR[0];
				maxR = valueR[1];
			}
			if (payload.newRevenueSlidervalue) {
				minR = payload.newRevenueSlidervalue[0];
				maxR = payload.newRevenueSlidervalue[1];
				min = value[0];
				max = value[1];
			}
			payload = {
				l1: selectedFilters.l1,
				l2: selectedFilters.l2,
				l3: selectedFilters.l3,
				districts: selectedFilters.district,
				suppliers: selectedFilters.supplier,
				priority: selectedFilters.priority,
				minGM: filterChange ? null : min,
				maxGM: filterChange ? null : max,
				minR: filterChange ? null : minR,
				maxR: filterChange ? null : maxR,
			};
			setTableLoading(true);
			let res = await dispatch(getPortfolioDistrictData(payload));
			if (res) {
				setTableData(res);
				set_Selected_product(null);
				setSelectedDistrict(null);
			}
			setTableLoading(false);
		}
	};

	const getPortfolioExport = async (payload: any = {}) => {
		toaster.push(messageExport, { placement: "topCenter" });
		if (selectedFilters.priority.length > 0) {
			let min = minSliderValue;
			let max = maxSliderValue;
			let minR = minRevenueSliderValue;
			let maxR = maxRevenueSliderValue;

			payload = {
				l1: selectedFilters.l1,
				l2: selectedFilters.l2,
				l3: selectedFilters.l3,
				districts: selectedFilters.district,
				suppliers: selectedFilters.supplier,
				priority: selectedFilters.priority,
				minGM: min,
				maxGM: max,
				minR: minR,
				maxR: maxR,
			};

			let res = await dispatch(getPortfolioGapExportData(payload));
			if (res) {
				res.map((item: any) => {
					item.totalNationalSales = `$${item.totalNationalSales.toFixed(
						0
					)}`;
					item.averageNationalGM = `${(
						item.averageNationalGM * 100
					).toFixed(2)}%`;
					item.unitCost = `$${item.unitCost?.toFixed(2)}`;
					item.unitPrice = `$${item.unitPrice?.toFixed(2)}`;
					item.additionalSales = `$${item.additionalSales?.toFixed(
						0
					)}`;
					item.marginBenefits = `$${item.marginBenefits?.toFixed(0)}`;
				});

				setExportData(res);
			}
		}
	};

	const getProductData = async () => {
		let min = value[0];
		let max = value[1];
		let minR = valueR[0];
		let maxR = valueR[1];
		let payload: any = {
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			districts: selectedFilters.district,
			suppliers: selectedFilters.supplier,
			priority: selectedFilters.priority,
			minGM: min,
			maxGM: max,
			minR: minR,
			maxR: maxR,
		};
		payload.district = [selectedDistrict];
		setTableLoading(true);
		let res = await dispatch(getPortfolioProductData(payload));
		if (res.length > 0) {
			setProductData(res);
		}
		setTableLoading(false);
	};

	const getPortfolioGapSKUData = async () => {
		let payload: any = {
			l1: selectedFilters.l1,
			l2: selectedFilters.l2,
			l3: selectedFilters.l3,
			districts: selectedFilters.district,
			suppliers: selectedFilters.supplier,
			priority: selectedFilters.priority,
		};
		payload.product_group_id = [product_group_id];
		setSkuLoading(true);
		let res = await dispatch(getPortfolioGapSKULevelData(payload));
		if (res) {
			for (const key in res?.productId) {
				res.productId[key] = res?.productId[key]?.sort(
					(a: any, b: any) => a?.material - b?.material
				);
			}

			setProduct_group_id_data(res);
		}
		setSkuLoading(false);
	};

	const message = (
		<Notification type={"info"} header={`Update`} closable>
			<p>Data Updated Successfully</p>
		</Notification>
	);

	const updatePortfolio = async () => {
		let payload: any = savePayload;
		payload.materials = updatedMaterialDetails;
		let res = await dispatch(updatePortfolioGap({ data: payload }));
		if (res.success) {
			setUpdatedMaterialDetails([]);
			setUpdatedMaterialList([]);
			toaster.push(message, { placement: "topCenter" });
			// getDistrictData();
		}
	};

	const exportExcel = () => {
		getPortfolioExport();
	};

	/* Updating filter selection state  */

	/* Updating filter options based on selection (api) */

	useEffect(() => {
		setProductData(null);
		setProduct_group_id_data(null);
		setProduct_group_id(null);
		set_Selected_product(null);
		if (selectedDistrict) {
			getProductData();
		}
	}, [selectedDistrict]);

	useEffect(() => {
		if (product_group_id) {
			getPortfolioGapSKUData();
		} else {
			setProduct_group_id_data(null);
			setProduct_group_id(null);
		}
	}, [product_group_id]);

	const handleChange = (newValue: any) => {
		setValue(newValue);
		getDistrictData({ newSlidervalue: newValue });
	};

	const handleRevenueChange = (newValue: any) => {
		setValueR(newValue);
		getDistrictData({ newRevenueSlidervalue: newValue });
	};

	const handleCheckboxUpdate = (
		materialId: any,
		currMaterialList: any,
		vendor: any
	) => {
		let cMaterial: any = [];

		product_group_id_data.vendorList.map((p: any) => {
			product_group_id_data.productId[p].map((item: any) => {
				cMaterial = [...cMaterial, item];
			});
		});

		let totalGM: any = 0;
		let totalQTY: any = 0;
		let recomendedGM: any = 0;
		let benefit: any = 0;
		let district: any = null;
		let groupid: any = null;
		let newSelectedFlag: any = null;

		cMaterial.map((currM: any) => {
			if (currM.selectedFlag == 1) {
				totalGM = totalGM + currM.skuGM * Number(currM.skuQty);
				totalQTY = totalQTY + Number(currM.skuQty);
			}
			if (currM.material == materialId) {
				newSelectedFlag = currM.selectedFlag;
			}
		});
		recomendedGM = totalQTY > 0 ? totalGM / totalQTY : 0;
		productData?.map((item: any) => {
			if (item?.product_group_id == selected_product?.product_group_id) {
				item.recomendedGM = recomendedGM;
				item.benefits_from_incremental_sales =
					recomendedGM * item.potential_incremental_sales;
				benefit = recomendedGM * item.potential_incremental_sales;
				district = item.district;
				groupid = item.product_group_id;
			}
		});
		// console.log('productData',productData);
		let existingMaterialFlag = false;
		updatedMaterialDetails.map((item: any) => {
			if (item.material == materialId) {
				item.selectedFlag = newSelectedFlag;
				existingMaterialFlag = true;
			}
		});
		if (!existingMaterialFlag) {
			setUpdatedMaterialDetails([
				...updatedMaterialDetails,
				{
					material: materialId,
					selectedFlag: newSelectedFlag,
					supplier: vendor,
				},
			]);
		}
		setSavePayload({
			materials: updatedMaterialDetails,
			margin: recomendedGM,
			marginbenefit: benefit,
			district: district,
			groupid: groupid,
		});
	};

	const handleSave = () => {
		updatePortfolio();
	};

	/* Updating filter selection state  */
	const handleFilterUpdate = (value: any, filter: string) => {
		let x: string = filter;
		if (value === "all") {
			if (filterOptions?.[x].length === selectedFilters?.[x].length) {
				setSelectedFilters({ ...selectedFilters, [x]: [] });
			} else {
				if (x == "supplier" || x == "priority") {
					setSelectedFilters({
						...selectedFilters,
						[x]: [
							...filterOptions?.[x].map(
								(option: any) => option.vendor
							),
						],
					});
				} else {
					setSelectedFilters({
						...selectedFilters,
						[x]: [
							...filterOptions?.[x].map(
								(option: any) => option?.[x]
							),
						],
					});
				}
			}
		} else {
			setSelectedFilters({ ...selectedFilters, [x]: [...value] });
		}
	};

	/* Updating filter options based on selection (api) */
	const handleClose = (filter: string) => {
		if (filter === "district") {
			setSelectedFilters({
				...selectedFilters,
				l1: [],
				l2: [],
				l3: [],
				supplier: [],
			});
			getFilters(
				{ ...selectedFilters, l1: [], l2: [], l3: [], supplier: [] },
				"district"
			);
		}
		if (filter === "l1") {
			setSelectedFilters({
				...selectedFilters,
				l2: [],
				l3: [],
				supplier: [],
			});
			getFilters(
				{ ...selectedFilters, l2: [], l3: [], supplier: [] },
				"l1"
			);
		}
		if (filter === "l2") {
			setSelectedFilters({ ...selectedFilters, l3: [], supplier: [] });
			getFilters({ ...selectedFilters, l3: [], supplier: [] }, "l2");
		}
		if (filter === "l3") {
			setSelectedFilters({ ...selectedFilters, supplier: [] });
			getFilters({ ...selectedFilters, supplier: [] }, "l3");
		}
		if (filter === "supplier") {
			getFilters({ ...selectedFilters }, "supplier");
		}
		if (filter === "priority") {
			getFilters({ ...selectedFilters }, "priority");
		}
	};

	useEffect(() => {
		setProductData(null);
		setProduct_group_id_data(null);
		setProduct_group_id(null);
		set_Selected_product(null);
		if (selectedDistrict) {
			getProductData();
		}
	}, [selectedDistrict]);

	useEffect(() => {
		if (product_group_id) {
			getPortfolioGapSKUData();
		} else {
			setProduct_group_id_data(null);
			setProduct_group_id(null);
		}
	}, [product_group_id]);

	useEffect(() => {
		if (exportData && exportData.length !== 0) {
			exportFullRef?.current?.link.click();
		}
	}, [exportData]);

	return isLoading ? (
		<Loader />
	) : (
		<div className="next-tier-dashboard-container w-full">
			<MainHeader
				onVisibilityChange={setIsVisible}
				isRightVisible={isRightVisible}
				setIsRightVisible={setIsRightVisible}
				topContent={
					<div className="flex justify-between items-center w-full">
						<div className="text-left pageline">
							<span className="pagelinestart">
								Assortment and Product
							</span>{" "}
							<span className="pagelineslash">/</span>{" "}
							<span className="pagelinesub">Portfolio Gap</span>
						</div>
					</div>
				}
				bottomContent={
					<div className="filter-flex gap-x-[1.5vh]">
						<div className="sub-heading-text font-bold flex flex-col items-start">
							<span className="filterHead ">Priority</span>
							<CheckPicker
								data={
									filterOptions?.priority.length
										? filterOptions?.priority
										: []
								}
								placeholder="All"
								labelKey="vendor"
								valueKey="vendor"
								value={
									selectedFilters.priority
										? selectedFilters.priority
										: []
								}
								onClose={() => handleClose("priority")}
								onChange={(value: any) =>
									handleFilterUpdate(value, "priority")
								}
								loading={filtersLoading}
								renderExtraFooter={() => (
									<div style={footerStyles}>
										<Checkbox
											indeterminate={
												selectedFilters.priority
													.length > 0 &&
												selectedFilters.priority
													.length <
													filterOptions?.priority
														.length
											}
											checked={
												selectedFilters.priority
													.length ===
												filterOptions?.priority.length
											}
											onChange={(value: any) =>
												handleFilterUpdate(
													"all",
													"priority"
												)
											}
										>
											Check all
										</Checkbox>
									</div>
								)}
							/>
						</div>
						<div className="sub-heading-text font-bold flex flex-col items-start">
							<span className="filterHead ">District</span>
							<CheckPicker
								data={
									filterOptions?.district.length
										? filterOptions?.district
										: []
								}
								placeholder="All"
								labelKey="district"
								valueKey="district"
								value={
									selectedFilters.district
										? selectedFilters.district
										: []
								}
								onClose={() => handleClose("district")}
								onChange={(value: any) =>
									handleFilterUpdate(value, "district")
								}
								cleanable={false}
								loading={filtersLoading}
								renderExtraFooter={() => (
									<div style={footerStyles}>
										<Checkbox
											indeterminate={
												selectedFilters.district
													.length > 0 &&
												selectedFilters.district
													.length <
													filterOptions?.district
														.length
											}
											checked={
												selectedFilters.district
													.length ===
												filterOptions?.district.length
											}
											onChange={(value: any) =>
												handleFilterUpdate(
													"all",
													"district"
												)
											}
										>
											Check all
										</Checkbox>
									</div>
								)}
							/>
						</div>
						<div className="sub-heading-text font-bold flex flex-col items-start">
							<span className="filterHead "> L1</span>
							<CheckPicker
								data={
									filterOptions?.l1.length
										? filterOptions?.l1
										: []
								}
								placeholder="All"
								labelKey="l1"
								valueKey="l1"
								value={
									selectedFilters.l1.length
										? selectedFilters.l1
										: []
								}
								onClose={() => handleClose("l1")}
								onChange={(value: any) =>
									handleFilterUpdate(value, "l1")
								}
								cleanable={false}
								loading={filtersLoading}
								renderExtraFooter={() => (
									<div style={footerStyles}>
										<Checkbox
											indeterminate={
												selectedFilters.l1.length > 0 &&
												selectedFilters.l1.length <
													filterOptions?.l1.length
											}
											checked={
												selectedFilters.l1.length ===
												filterOptions?.l1.length
											}
											onChange={(value: any) =>
												handleFilterUpdate("all", "l1")
											}
										>
											Check all
										</Checkbox>
									</div>
								)}
							/>
						</div>
						<div className="sub-heading-text font-bold flex flex-col items-start">
							<span className="filterHead "> L2</span>
							<CheckPicker
								data={
									filterOptions?.l2.length
										? filterOptions?.l2
										: []
								}
								placeholder="All"
								labelKey="l2"
								valueKey="l2"
								value={
									selectedFilters.l2.length
										? selectedFilters.l2
										: []
								}
								onClose={() => handleClose("l2")}
								onChange={(value: any) =>
									handleFilterUpdate(value, "l2")
								}
								cleanable={false}
								loading={filtersLoading}
								renderExtraFooter={() => (
									<div style={footerStyles}>
										<Checkbox
											indeterminate={
												selectedFilters.l2.length > 0 &&
												selectedFilters.l2.length <
													filterOptions?.l2.length
											}
											checked={
												selectedFilters.l2.length ===
												filterOptions?.l2.length
											}
											onChange={(value: any) =>
												handleFilterUpdate("all", "l2")
											}
										>
											Check all
										</Checkbox>
									</div>
								)}
							/>
						</div>
						<div className="sub-heading-text font-bold flex flex-col items-start">
							<span className="filterHead ">L3</span>
							<CheckPicker
								data={
									filterOptions?.l3.length
										? filterOptions?.l3
										: []
								}
								placeholder="All"
								labelKey="l3"
								valueKey="l3"
								value={
									selectedFilters.l3.length
										? selectedFilters.l3
										: []
								}
								onClose={() => handleClose("l3")}
								onChange={(value: any) =>
									handleFilterUpdate(value, "l3")
								}
								cleanable={false}
								loading={filtersLoading}
								renderExtraFooter={() => (
									<div style={footerStyles}>
										<Checkbox
											indeterminate={
												selectedFilters.l3.length > 0 &&
												selectedFilters.l3.length <
													filterOptions?.l3.length
											}
											checked={
												selectedFilters.l3.length ===
												filterOptions?.l3.length
											}
											onChange={(value: any) =>
												handleFilterUpdate("all", "l3")
											}
										>
											Check all
										</Checkbox>
									</div>
								)}
							/>
						</div>
						<div className="sub-heading-text font-bold flex flex-col items-start">
							<span className="filterHead ">L4</span>
							<CheckPicker
								data={
									filterOptions?.supplier.length
										? filterOptions?.supplier
										: []
								}
								placeholder="All"
								labelKey="l4"
								valueKey="l4"
								virtualized
								value={
									selectedFilters.supplier.length
										? selectedFilters.supplier
										: []
								}
								onClose={() => handleClose("supplier")}
								onChange={(value: any) =>
									handleFilterUpdate(value, "supplier")
								}
								cleanable={false}
								loading={filtersLoading}
								renderExtraFooter={() => (
									<div style={footerStyles}>
										<Checkbox
											indeterminate={
												selectedFilters.supplier
													.length > 0 &&
												selectedFilters.supplier
													.length <
													filterOptions?.supplier
														.length
											}
											checked={
												selectedFilters.supplier
													.length ===
												filterOptions?.supplier.length
											}
											onChange={(value: any) =>
												handleFilterUpdate(
													"all",
													"supplier"
												)
											}
										>
											Check all
										</Checkbox>
									</div>
								)}
							/>
						</div>
						<div className="sub-heading-text font-bold flex flex-col items-start">
							<span className="filterHead capitalize">
								Timeline
							</span>
							<SelectPicker
								data={
									timelineOptions.length
										? timelineOptions
										: []
								}
								placeholder="All"
								value={selectedTimeline}
								defaultValue={
									timelineOptions.length
										? timelineOptions[0].value
										: ""
								}
								onChange={timelineHandler}
								cleanable={false}
							/>
						</div>
						<div className="sub-heading-text font-bold flex flex-col items-start ml-2">
							<span className="filterHead capitalize !mb-[1vh] !mt-[1.5vh]">
								Gross Margin(%) Threshold
							</span>
							<div className="w-[14vw] pr-[2vw] pt-[.5vh] custom-slider">
								<RangeSlider
									value={value}
									graduated
									progress
									min={minSliderValue}
									max={maxSliderValue}
									onChangeCommitted={handleChange}
									renderMark={(mark) => {
										if (
											[value[0], value[1]].includes(mark)
										) {
											if (mark == value[0]) {
												return <span>{mark}</span>;
											} else if (mark == value[1]) {
												return <span>{mark}</span>;
											}
										}
										return null;
									}}
								/>
							</div>
						</div>
						<div className="sub-heading-text font-bold flex flex-col items-start">
							<span className="filterHead capitalize !mb-[1vh] !mt-[1.5vh]">
								Revenue($) Threshold
							</span>
							<div className="w-[14vw] pr-[2vw] pt-[.5vh] custom-slider">
								<RangeSlider
									value={valueR}
									step={10000}
									graduated
									progress
									min={minRevenueSliderValue}
									max={maxRevenueSliderValue}
									onChangeCommitted={handleRevenueChange}
									renderMark={(mark) => {
										if (
											[valueR[0], valueR[1]].includes(
												mark
											)
										) {
											if (mark == valueR[0]) {
												return (
													<span>
														{numberFormatter(
															mark,
															0
														)}
													</span>
												);
											} else if (
												mark ==
												valueR[1] - (valueR[1] % 10000)
											) {
												return (
													<span>
														{numberFormatter(
															mark,
															0
														)}
													</span>
												);
											}
										}
										return null;
									}}
								/>
							</div>
						</div>
					</div>
				}
			></MainHeader>
			<MainContent isVisible={isVisible} fullHeight={true}>
				<div
					className={`${
						!isVisible ? "h-[76vh]" : "h-[64vh]"
					} chart-flex `}
				>
					<div className="district-data contentBox !w-[50%]">
						{
							<>
								<div className="common-table-header-row !mb-0">
									<span className="common-table-header">
										Portfolio Table
									</span>
									<div className="buttonWrapper flex">
										<Button
											className="bg-transparent hover:bg-transparent"
											onClick={exportExcel}
										>
											<FileDownloadIcon
												color="black"
												className="text-fsre15"
											/>
										</Button>
										<CSVLink
											ref={exportFullRef}
											data={exportData}
											headers={csvHeaders}
											filename="portfolio.csv"
											className="hidden"
											target="_blank"
										>
											{" "}
										</CSVLink>
									</div>
								</div>
								<PortfolioTable
									data={tableData}
									selectedDistrict={selectedDistrict}
									handleDistrictClick={(
										district: string | null
									) => setSelectedDistrict(district)}
									productData={productData}
									loading={tableLoading}
									handleProductClick={(
										product: ProductData | null
									) => {
										set_Selected_product(product);
										setProduct_group_id(
											product?.product_group_id || null
										);
										setUpdatedMaterialDetails([]);
										setUpdatedMaterialList([]);
									}}
									selectedProductId={product_group_id}
								/>
							</>
						}
					</div>
					<div className="product-data contentBox !w-[50%] flex justify-center items-center p-[1%] bg-[#fff]">
						{selected_product ? (
							<ProductGroupDetails
								loading={skuLoading}
								selectedProduct={selected_product}
								skuData={product_group_id_data}
								updateMaterials={(
									materialId: any,
									currMaterialList: any,
									vendor: any
								) => {
									setUpdatedMaterialList([
										...updatedMaterialList,
										materialId,
									]);
									handleCheckboxUpdate(
										materialId,
										currMaterialList,
										vendor
									);
								}}
								handleSave={() => {
									handleSave();
								}}
								materialList={updatedMaterialList}
							></ProductGroupDetails>
						) : (
							<span className="flex justify-center italic text-center items-center text-[2.5vh] font-normal text-black">
								Please select the District and then the Product
								Group ID to see additional details (such as
								items included in group, districts where
								currently sold, billing qty., sales, etc.)
							</span>
						)}
					</div>
				</div>
			</MainContent>
		</div>
	);
};

const messageExport = (
	<Notification type={"info"} header={`Exporting...`} closable>
		<p>Your file is being created. It will be downloaded automatically</p>
	</Notification>
);

export default PortfolioGap;
